import { render, staticRenderFns } from "./SumaryBankRelationship.vue?vue&type=template&id=1877712e&"
import script from "./SumaryBankRelationship.vue?vue&type=script&lang=js&"
export * from "./SumaryBankRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports